import { render, staticRenderFns } from "./Wishlistshare.vue?vue&type=template&id=34ca19f4&"
import script from "./Wishlistshare.vue?vue&type=script&lang=js&"
export * from "./Wishlistshare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports